import styled from 'styled-components';

export const BlockContainer = styled.div`
  display: flex;
  justify-content: center;
  .title {
    height: 8rem;
  }
`;
